webpackJsonp([235554121860001],{

/***/ 1555:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/multires/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-multires-373c0d4d2ce1afebbc33.js